module.exports = __webpack_public_path__ + "img/search-right.9b53ae52.png";